module.exports = __webpack_public_path__ + "img/secondary_1x3.95be5137.svg";